module.exports = __webpack_public_path__ + "img/electric_icon_prise-renforcee.0a18c35c.svg";